<template>
  <div class="maturity-level">
    <div v-for="(level, index) in levels" :key="index" class="maturity-level-item fade-in"
      :class="{ active: selectedLevel === index }" :data-level="index" @click="selectLevel(index)">
      <div class="level">Nível {{ index }}</div>
      <div class="number" :class="level.statusClass">{{ level.status }}</div>
      <div class="description">{{ level.description }}</div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'

const selectedLevel = ref(0)

const selectLevel = (index) => {
  selectedLevel.value = index
}

const levels = [
  {
    status: 'Não Implementado',
    statusClass: 'not-implemented',
    description: 'Falta de processos reconhecidos',
  },
  {
    status: 'Parcial',
    statusClass: 'partial',
    description: 'Controles em aplicação com questões a resolver',
  },
  {
    status: 'Implementado',
    statusClass: 'implemented',
    description: 'Processos refinados com boas práticas',
  },
  {
    status: 'Gerenciado',
    statusClass: 'managed',
    description: 'Processos monitorados e medidos',
  },
  {
    status: 'Otimizado',
    statusClass: 'optimized',
    description: 'Melhoria contínua baseada em métricas',
  },
]
</script>
<style scoped>
.maturity-level {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  box-sizing: border-box;
  padding: 0 1rem;

}

.maturity-level-item {
  background: #f9f9f9;
  padding: 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 4px solid transparent;
  box-sizing: border-box;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 200px;
  max-width: 300px;
  min-width: 180px;

}

.maturity-level-item.active {
  border-bottom: 4px solid #66b2ff;
  background-color: #eef7ff;
}

/* responsividade */

@media (max-width: 768px) {
  .maturity-level-item {
    flex-basis: 45%;
    max-width: 100%;
    margin-bottom: 1rem;
  }
}

@media (max-width: 480px) {
  .maturity-level-item {
    flex-basis: 100%;
    max-width: 100%;
  }
}

.level {
  font-weight: bold;
  margin-bottom: 0.5rem;
}

.number {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}

.not-implemented {
  color: red;
}

.partial {
  color: orange;
}

.implemented {
  color: green;
}

.managed {
  color: blue;
}

.optimized {
  color: purple;
}

.fade-in {
  opacity: 0;
  animation: fadeIn 0.6s forwards;
}

@keyframes fadeIn {
  to {
    opacity: 1;
  }
}

/* Responsividade */

@media (max-width: 768px) {
  .maturity-level {
    justify-content: flex-start;
  }

  .maturity-level-item {
    flex: 1 1 45%;
    /* ocupa cerca de 2 por linha */
    max-width: 45%;
    margin-bottom: 1rem;
  }
}

@media (max-width: 480px) {
  .maturity-level-item {
    flex: 1 1 100%;
    /* ocupa toda a largura no celular */
    max-width: 100%;
  }
}
</style>
